import { memo, useRef } from 'react';
import { outsideClick } from '../../utils/hooks';
import './modal.scss';
export interface ModalProps {
    isOpen: boolean;
    openModal: (openState: boolean) => void;
    children: JSX.Element[] | JSX.Element | string;
    title: string;
    className?: string;
}
function Modal({ isOpen, openModal, children, title, className }: ModalProps) {

    const outerRef = useRef<HTMLDivElement>(null);
    outsideClick(outerRef, openModal);

    return (
        <div className={'outer-modal modal' + (isOpen ? ' visible' : ' hidden')} data-testid='modal-wrapper'>
            <div ref={outerRef} className={'modal-container' + (className ? ' ' + className : '')} data-cy='modal-content'>
                <a className='overlay-close' onClick={() => openModal(false)} role='button' tabIndex={0} aria-label='Close overlay'>
                    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 50 50' className='close-modal-icon'>
                        <title>Close overlay</title>
                        <path d='M42.6 35.9L31.7 25.1l10.9-10.9c1.9-1.9 1.9-4.9 0-6.7s-4.9-1.9-6.7 0L25 18.4 14.1 7.5c-1.9-1.9-4.9-1.9-6.7 0s-1.9 4.9 0 6.7l10.9 10.9L7.4 35.9c-1.9 1.9-1.9 4.9 0 6.7 1.9 1.9 4.9 1.9 6.7 0L25 31.8l10.9 10.9c1.9 1.9 4.9 1.9 6.7 0s1.9-4.9 0-6.8z'></path>
                    </svg>
                </a>
                <h2 className='modal-title'>{title}</h2>
                <div className='modal-content'>
                    {children}
                </div>
            </div>
        </div>
    );
}

export default memo(Modal);